import React from "react";
import { Redirect } from "react-router-dom";
import LoginForm from "./LoginForm.jsx";
import { useOktaAuth } from '@okta/okta-react';

const Login = ({ issuer }) => {
  const { authState } = useOktaAuth();

  if (!authState) {
    return <div>Loading...</div>;
  }
  return authState.isAuthenticated ?
    <Redirect to={{ pathname: '/' }} /> :
    <LoginForm issuer={issuer} />;
}

export default Login;


// import React, { Component } from "react";
// import { Redirect } from "react-router-dom";
// import LoginForm from "./LoginForm";
// import { withAuth } from "@okta/okta-react";

// class Login extends Component {
//   constructor(props) {
//     super(props);
//     this.state = { authenticated: null };
//     this.checkAuthentication = this.checkAuthentication.bind(this);
//     this.checkAuthentication();
//   }

//   async checkAuthentication() {
//     const authenticated = await this.props.auth.isAuthenticated();
//     if (authenticated !== this.state.authenticated) {
//       this.setState({ authenticated });
//     }
//   }

//   componentDidUpdate() {
//     this.checkAuthentication();
//   }

//   render() {
//     if (this.state.authenticated === null) return null;
//     return this.state.authenticated ? (
//       <Redirect to={{ pathname: "/profile" }} />
//     ) : (
//       <LoginForm baseUrl={this.props.baseUrl} />
//     );
//   }
// }

// export default withAuth(Login);
